import React, { useState } from "react";
import "../ModalMouqabale.styles.scss";
import {
  TCreneau,
  TMiniProfil,
  TMouqabalaStep,
} from "@/features/profile/types";
import { Button, IconButton, Modal } from "@mui/material";
import { InlineIcon } from "@iconify/react";
import LoaderMini from "@/components/Loader-mini/LoaderMini";
import {
  apiMouqabalaStripe,
  apiMouqabalaPaypal,
  apiMouqabalaPaypalAprrove,
} from "@/features/profile/api/mouqabala.api";
import { Toastify } from "@/utils/toast";
import { HighlightOffRounded } from "@mui/icons-material";

interface MouqCreneauReservedProps {
  setStep?: React.Dispatch<React.SetStateAction<TMouqabalaStep>>;
  close?: () => void;
  receiver: TMiniProfil | null;
  selectedCreneau: Partial<TCreneau>;
  mouqabala_id: string;
}
const MouqCreneauReserved = ({
  close,
  receiver,
  selectedCreneau,
  mouqabala_id,
}: MouqCreneauReservedProps) => {
  const [openPayment, setOpenPayment] = useState(false);
  const handleOpenPayment = () => setOpenPayment(true);
  const [loading, setLoading] = useState(false);
  const handleClosePayment = () => {
    setOpenPayment(false);
  };

  const stripeInitPayment = (data: any = "") => {
    console.log(data);

    // Toastify('success',`As salemou 'alaikoum ${'Landry'}, tu es maintenant connectée.`);
    setLoading(true);

    apiMouqabalaStripe({
      appointmentRequestId: mouqabala_id,
      appointmentSlotId: selectedCreneau.id_creneau!?.toString(),
    })
      .then((response: any) => {
        setLoading(false);
        console.log(response);

        const redirect_url = response.data;

        const linkToStripe = document.createElement("a");

        linkToStripe.setAttribute("href", redirect_url);
        // linkToStripe.setAttribute('target','_blank');
        linkToStripe.click();

        linkToStripe.remove();
      })
      .catch((error: any) => {
        setLoading(false);
        Toastify(`${error?.response?.data?.message}`, "error", 5000);
      })
      .finally(() => {
        handleClosePayment();
      });
  };

  const createOrderpaypal = (): any => {
    return apiMouqabalaPaypal({
      appointmentRequestId: mouqabala_id,
      appointmentSlotId: selectedCreneau.id_creneau!?.toString(),
    }).then((response) => {
      return response.data.id;
    });
  };

  const onApprove = (data: any) => {
    console.log({ mouqabala_id, data }, selectedCreneau.id_creneau);
    // replace this url with your server
    return apiMouqabalaPaypalAprrove({
      appointmentRequestId: mouqabala_id,
      appointmentSlotId: selectedCreneau.id_creneau!?.toString(),
      orderId: data.orderID,
    })
      .then((response) => {
        handleClosePayment();
        close?.();
      })
      .finally(() => {
        handleClosePayment();
        close?.();
      });
  };

  console.log({ receiver });

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
        <div className="rules confirm-alt">
          <div className="rules__icon-success">
            <InlineIcon
              icon="fluent:calendar-32-regular"
              className="icon creneau"
            />
          </div>
          <p className="rules__title-alt">
            Le Créneau du <b>{selectedCreneau.creneau_date}</b> De{" "}
            <b>{selectedCreneau.creneau_start_time}</b> à{" "}
            <b>{selectedCreneau.creneau_end_time}</b> avec{" "}
            <span style={{ color: "var(--ui-tertiary-shade" }}>
              {receiver?.username}
            </span>{" "}
            est en attente de paiement.
          </p>
          <p className="rules__subtitle-alt">
            <span style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
              ⚠️ &nbsp;Attention
            </span>{" "}
            <ul
              style={{
                width: "100%",
                textAlign: "left",
                listStyle: "none",
                fontWeight: 400,
              }}
            >
              <li>• Un créneau est réservé que lorsqu'il a été payé</li>
              <li>
                • Vous disposez de <b>10 min</b> pour effectuer un paiement
                sinon vous perdrez ce créneau.
              </li>
            </ul>
          </p>
          <Button
            variant="contained"
            className="rules__confirm"
            onClick={() => {
              // close!();
              handleOpenPayment();
            }}
            color="primary"
            startIcon={<InlineIcon icon="fluent:payment-32-regular" />}
          >
            Procéder au paiement
          </Button>
        </div>
      </div>

      {/* PAYMENT */}
      <Modal
        open={openPayment}
        onClose={handleClosePayment}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <>
          <div className="modal-mouqabala-payment">
            <IconButton
              className="close-icon"
              size="large"
              color="inherit"
              onClick={handleClosePayment}
            >
              <HighlightOffRounded />
            </IconButton>
            <img
              src={require("@/assets/images/jpeg/errorHandlerImage.jpeg")}
              alt="sidebar-logo"
              className="modal-avatar"
            />
            <p>
              Vous êtes sur le point de payer pour une Mouqabala de{" "}
              <b className="wha"> {selectedCreneau.creneau_duration} </b> de{" "}
              <b className="wha">{selectedCreneau.creneau_start_time}</b> à{" "}
              <b className="wha">{selectedCreneau.creneau_end_time}</b> le{" "}
              <b className="wha">{selectedCreneau.creneau_date}</b>.<br />
              {/* avec{" "}
              <b>{receiver.username}</b>.<br /> */}
            </p>

            {loading ? (
              <LoaderMini />
            ) : (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ marginBottom: "20px" }}
                  onClick={() => {
                    stripeInitPayment("");
                  }}
                >
                  Payer par carte bancaire&nbsp;
                  <img
                    src={require("@/assets/images/png/pay-by-cb.png")}
                    alt="pay-by-cb"
                    width={50}
                  />
                </Button>

                {/* <PayPalButtons
                  className="btn-paypal"
                  fundingSource="paypal"
                  forceReRender={[{ layout: "vertical" }]}
                  style={{ layout: "vertical" }}
                  createOrder={createOrderpaypal}
                  onApprove={onApprove}
                /> */}
              </>
            )}
          </div>
        </>
      </Modal>
      {/* End of PAYMENT */}
    </>
  );
};

export default MouqCreneauReserved;
